import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "ta-e" };
const _hoisted_2 = { class: "ta-e" };
const _hoisted_3 = { class: "ta-e" };
const _hoisted_4 = { class: "ta-e" };
const _hoisted_5 = { class: "ta-e" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    return (_openBlock(), _createElementBlock("tr", null, [
        _createCommentVNode(" 대행료 시작(이상) "),
        _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.fromAmount), 1 /* TEXT */),
        _createCommentVNode(" 대행료 종료(이하) "),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.toAmount), 1 /* TEXT */),
        _createCommentVNode(" 수수료 정액 "),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.fee), 1 /* TEXT */),
        _createCommentVNode(" 수수료 정률 "),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.lc}percent`, { percent: _ctx.rate })), 1 /* TEXT */),
        _createCommentVNode(" 대행료 수정 및 삭제 "),
        _createElementVNode("td", _hoisted_5, [
            _createCommentVNode(" 수정 "),
            _createVNode(_component_v_btn, {
                icon: "mdi-pencil-outline",
                variant: "text",
                density: "comfortable",
                onClick: _withModifiers(_ctx.handleClickEditDialogBtn, ["stop"])
            }, null, 8 /* PROPS */, ["onClick"]),
            _createCommentVNode(" 삭제 "),
            _createVNode(_component_v_btn, {
                icon: "mdi-trash-can-outline",
                variant: "text",
                density: "comfortable",
                onClick: _withModifiers(_ctx.handleClickDelete, ["stop"])
            }, null, 8 /* PROPS */, ["onClick"])
        ])
    ]));
}
